<template>
  <div class="avg_marker" :style="markerStyle">
    <div class="avg_text" v-if="fitMode === 'width'" ref="markerText"
      :style="{ left: -this.markerTextWidth + 10 + 'px' }">
      {{ 'averageFold' }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeatmapAvgFold',
  props: [
    'avgFoldData',
    'scale',
    'fitMode'
  ],
  data () {
    return {
      markerTextWidth: 0
    }
  },
  computed: {
    markerStyle () {
      const left = this.fitMode === 'width' ? this.markerTextWidth - 10 : 0
      return {
        top: (this.avgFoldData * this.scale) + 'px',
        left: left + 'px'
      }
    }
  },
  watch: {
    fitMode (value) {
      this.$nextTick().then(() => {
        this.setMarkerTextWidth()
      })
    }
  },
  mounted () {
    this.setMarkerTextWidth()
  },
  methods: {
    setMarkerTextWidth () {
      if (this.$refs.markerText && !this.markerTextWidth) {
        this.markerTextWidth = this.$refs.markerText.offsetWidth
      }
    }
  }
}
</script>

<style lang="scss">
.avg_marker {
  position: absolute;
  top: 0;
  right: 0;
  border-bottom: 2px dotted #fff;
  z-index: 100;
  pointer-events: none;

  .avg_text {
    position: absolute;
    bottom: -12px;
    text-transform: uppercase;
    font-size: 12px;
    color: #ffffff;
    background-image: url(../../../assets/img/heatmap/heatmap_average_fold.svg);
    background-repeat: no-repeat;
    background-position: -10px -5px;
    line-height: 20px;
    text-indent: 4px;
    width: 110px;
    height: 40px;
    transform: translateY(19px);
  }
}
</style>
